export const colors = {
  white: '#ffffff',
  disableGroupFont: '#a39e9e',
  disableGroupBackground: '#eceff5',
  whiteTwo: '#fbfbfb',
  black: '#191919',
  backgroundBar: '#e2e7ee',
  backgroundFilter: '#f7f7f7',
  backgroundGeneral: '#eff3f6',
  main: '#2ea2f8',
  mainLight: '#d5edff',
  darkTypo: '#4d4d4d',
  darkStrong: '#273142',
  darkGreyBlue: '#354052',
  disabled: '#b0b0b1',
  border: '#dfe3e9',
  silver: '#dfe2e5',
  silverTwo: '#ced0da',
  greyTypo: '#7f8fa4',
  paleGrey: '#e9edf1',
  paleGreyTwo: '#fafbfc',
  paleGreyThree: '#f0f3f8',
  paleGreyFour: '#e6eaee',
  success: '#39b54a',
  successLight: '#1bb934',
  errorStrong: '#ed1c24',
  errorLight: '#ffebeb',
  error: '#f85359',
  squash: '#f7981c',
  yellowCard: '#fff324',
  transparentBorder: 'rgba(0, 0, 0, 0.1)',
  primaryActiveButton: '#167bd4',
  secondaryHoverButton: '#dfe4ed',
  secondaryActiveButton: '#cbcfd7',
  overlayBackground: 'rgba(19, 24, 32, 0.8)',
  keenvil: 'rgba(117,80,194,1)',
  keenvilLight: 'rgba(117,80,194,0.5)'
};
